export default __webpack_public_path__ + "static/media/Gotham-Medium.0aff23d7.otf";